export default __webpack_public_path__ + "static/media/virtual.d2ae431c.svg";